import React from 'react';
import config from '../../config';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Spinner from 'react-spinkit';
import { Row, Col, Pagination, Badge, HelpBlock } from 'react-bootstrap';
import Dropzone from 'react-dropzone';
import { formValueSelector } from 'redux-form';
import * as runActions from '../../actions/runsActionCreators';
import * as courseActions from '../../actions/coursesActionCreators';
import * as commonActions from '../../actions/commonActions';
import * as studentsActions from '../../actions/studentsActionCreators';
import * as groupActions from '../../actions/groupActionCreators';
import { browserHistory, Link } from 'react-router';
import AdminSteps from '../common/AdminSteps';
import label from '../../utils/lngEn';
import RunForm from './RunForm';
import AddConflictModal from './AddConflictModal';
import AddRequirementModal from './AddRequirementModal';
import toastr from 'toastr';
import ConflictRow from './ConflictRow';
import RequirementRow from './RequirementRow';
import moment from 'moment';
import ConfirmDeleteModal from '../common/ConfirmDeleteModal';
import OpenRankingSessionIdModal from './OpenRankingSessionModal';
import SelectAssignmentForm from './SelectAssignmentForm';
import AddDropPeriodComponent from './AddDropPeriodComponent';

class RunPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    let progress = 0;
    if (this.props.run.id && this.props.run.students) {
      progress = ((this.props.run.students_with_rankings * 100) / this.props.run.students).toFixed(1);
    }

    this.state = {
      showRankingSessionModal: null,
      showConfirmRestrictionDelete: false,
      deleteRestrictionId: '',
      deleteRestrictionType: '',
      confirmDeleteRestrictionTitle: '',
      confirmDeleteRestrictionMsg: '',
      conflicts: [],
      requirements: [],
      startConf: 0,
      endConf: config.tableConflictNum,
      startReq: 0,
      endReq: config.tableConflictNum,
      activeConflictPage: 1,
      activeReqPage: 1,
      coursesLoaded: false,
      progress: progress,
      progressMsg: '',
      showConfModal: false,
      showReqModal: false,
      progressStatus: '',
      submittingRunFormProgress: false,
      downloadExcelProgress: false,
      downloadJsonProgress: false,
      openRankingSessionStatus: false,
      closeRankingSessionStatus: false,
      assignClassesStatus: false,
      cancelAssignClassesStatus: false,
      uploadFileStatus: false,
      computation: {
        running: false
      },
      conflictModalValues: {
        title: '',
        gsId: '',
        initialValues: {
          is_time_conflict: false
        }
      },
      reqModalValues: {
        title: '',
        gsId: '',
        initialValues: {
          is_time_conflict: false
        }
      },
      studentsLoaded: false,
      assignmentSummaryProgress: false
    };

    this.handleRunFormSubmit = this.handleRunFormSubmit.bind(this);
    this.handleOnDrop = this.handleOnDrop.bind(this);
    this.openAddConflictModal = this.openAddConflictModal.bind(this);
    this.openEditConflictModal = this.openEditConflictModal.bind(this);
    this.closeAddConflictModal = this.closeAddConflictModal.bind(this);
    this.progressStatus = this.progressStatus.bind(this);
    this.handleOpenRankingSession = this.handleOpenRankingSession.bind(this);
    this.handleCloseRankingSession = this.handleCloseRankingSession.bind(this);
    this.handleAssignClasses = this.handleAssignClasses.bind(this);
    this.handleCancelAssignment = this.handleCancelAssignment.bind(this);
    this.handleConflictPageChange = this.handleConflictPageChange.bind(this);
    this.setRestrictionsToState = this.setRestrictionsToState.bind(this);
    this.cRunningComp = this.cRunningComp.bind(this);

    this.loopComputationStatus = this.loopComputationStatus.bind(this);
    this.openAddReqModal = this.openAddReqModal.bind(this);
    this.openEditReqModal = this.openEditReqModal.bind(this);
    this.closeAddReqModal = this.closeAddReqModal.bind(this);
    this.showConfirmRestrictionDeleteModal = this.showConfirmRestrictionDeleteModal.bind(this);
    this.handleDeleteRestriction = this.handleDeleteRestriction.bind(this);
    this.closeDeleteModal = this.closeDeleteModal.bind(this);
    this.handleRequirementPageChange = this.handleRequirementPageChange.bind(this);

    this.handleRestrictionSearch = this.handleRestrictionSearch.bind(this);
    this.handleAssignmentSummary = this.handleAssignmentSummary.bind(this);
  }

  componentWillMount() {
    let auth = localStorage.getObject('auth');
    if (auth) {
      this.props.runActions.getRun();
      this.props.commonActions.getAllRestrictions(config.conflicts).catch(() => {
      });
      this.props.commonActions.getAllRestrictions(config.requirements).catch(() => {
      });
      this.props.courseActions.getAllCourses().then(() => {
        if (this.refs.restrictions) {
          this.setState({ coursesLoaded: true });
        }
      });
      this.props.studentsActions.getAllStudents().then(() => {
        this.setState({ studentsLoaded: true });
      });
      this.props.groupActions.getAllGroups();
    } else {
      browserHistory.push('/administer/' + localStorage.getItem('run') + '/' + localStorage.getItem('login'));
    }
  }

  componentDidMount() {
    this.props.runActions.getFinishedComputations()
      .then(() => {})
      .catch(err => {});
    if (localStorage.getItem('downloadTime')) {
      let obj = JSON.parse(localStorage.getItem('downloadFile'));
      toastr.info('Downloading of .' + obj.fileType + ' file continues...');
      this.makeOutput(obj.computation, obj.fileType);
    } else if (localStorage.getItem('assignTime')) {
      let url = localStorage.getItem('assignUrl');
      this.setState({ assignClassesStatus: true });
      this.props.runActions.continueStartRun(url).then(() => {
        this.setState({ assignClassesStatus: false });
        this.props.runActions.getRun();
      });
    } else if (localStorage.getItem('assignStopTime')) {
      let url = localStorage.getItem('assignStopUrl');
      this.setState({ cancelAssignClassesStatus: true });
      this.props.runActions
        .continueStopRun(url)
        .then(() => {
          this.setState({ cancelAssignClassesStatus: false });
          this.props.runActions.getRun();
        })
        .catch(() => {
          toastr.error('Time Out reached. Try again in few minutes.');
        });
    } else if (localStorage.getItem('uploadFileTime')) {
      let url = localStorage.getItem('uploadFileUrl');
      this.setState({ uploadFileStatus: true });
      this.props.runActions.continueFileUpload(url).then(() => {
        this.setState({ uploadFileStatus: false });
        this.props.runActions.getRun();
        this.props.commonActions.getAllRestrictions(config.conflicts).catch(() => {
        });
        this.props.commonActions.getAllRestrictions(config.requirements).catch(() => {
        });
        this.props.courseActions.getAllCourses().then(() => {
          if (this.refs.restrictions) {
            this.setState({ coursesLoaded: true });
          }
        });
        this.props.studentsActions.getAllStudents();
        this.props.groupActions.getAllGroups();
      });
    } else if (localStorage.getItem('allocationsTime')) {
      let url = localStorage.getItem('allocationsUrl');
      this.setState({ assignmentSummaryProgress: true });

      Promise.all([
        this.props.courseActions.getAllCourses(),
        this.props.studentsActions.getAllStudents(),
        this.props.groupActions.getAllGroups()
      ])
        .then(() => {
          this.props.runActions
            .continueGetAllocations(url)
            .then(() => {
              this.setState({ assignmentSummaryProgress: false });
              this.props.runActions.getRun().then(() => {
                let runName = localStorage.getItem('run');
                browserHistory.push('/administer/' + runName + '/assignment/dashboard');
              });
            })
            .catch(err => {
              this.setState({ assignmentSummaryProgress: false });
              toastr.error('Time Out reached. Try again in few minutes.');
            });
        })
        .catch(() => {
          this.setState({ assignmentSummaryProgress: false });
          toastr.error('Error');
        });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.run.id) {
      // Check if finished computations changed
      const oldFinishedComputations = this.props.run.finishedComputations || [];
      const newFinishedComputations = nextProps.run.finishedComputations || [];
      
      this.progressStatus(nextProps.run);
      let progress = ((nextProps.run.students_with_rankings * 100) / nextProps.run.students).toFixed(1);
      let msg = nextProps.run.students_with_rankings + ' of ' + nextProps.run.students + ' students.';
      this.setState({ progressMsg: msg });
      if (!isNaN(progress)) {
        this.setState({ progress: progress });
      }
      if (nextProps.run.running_computations[0] && !this.state.computation.running) {
        let id = nextProps.run.running_computations[0];
        this.cRunningComp(id);
        this.loopComputationStatus(id);
      }
    }
    if (nextProps.courses.length != this.props.courses.length && nextProps.courses.length > 0) {
      this.setState({ coursesLoaded: true });
      this.setRestrictionsToState(this.props.conflicts, config.conflicts);
      this.setRestrictionsToState(this.props.requirements, config.requirements);
    }
    if (this.props.conflicts != nextProps.conflicts) {
      this.setRestrictionsToState(nextProps.conflicts, config.conflicts);
    }
    if (this.props.requirements != nextProps.requirements) {
      this.setRestrictionsToState(nextProps.requirements, config.requirements);
    }
  }

  // Add Conflict Modal
  openAddConflictModal() {
    this.setState({
      showConfModal: true,
      conflictModalValues: {
        title: `${label.createConflict}`,
        initialValues: {
          is_time_conflict: false
        }
      }
    });
  }

  // Edit Conflict Modal
  openEditConflictModal(conflict) {
    this.setState({
      showConfModal: true,
      conflictModalValues: {
        title: `${label.editConflict}`,
        initialValues: {
          is_time_conflict: false,
          id: conflict.id,
          name: conflict.name,
          kind: conflict.kind.toString(),
          limit: conflict.limit.toString(),
          courses: conflict.courses
        }
      }
    });
  }

  closeAddConflictModal() {
    this.setState({ showConfModal: false });
  }

  // Add Requirement Modal
  openAddReqModal() {
    this.setState({
      showReqModal: true,
      reqModalValues: {
        title: `${label.createRequirement}`,
        initialValues: {}
      }
    });
  }

  // Edit Requirement Modal
  openEditReqModal(req) {
    this.setState({
      showReqModal: true,
      reqModalValues: {
        title: `${label.editRequirement}`,
        initialValues: {
          id: req.id,
          name: req.name,
          kind: req.kind.toString(),
          limit: req.limit.toString(),
          courses: req.courses
        }
      }
    });
  }

  closeAddReqModal() {
    this.setState({ showReqModal: false });
  }

  // Confirm Delete Requirement Modal
  showConfirmRestrictionDeleteModal(id, type) {
    let item;
    if (type == config.conflicts) {
      item = this.state.conflicts.filter(r => {
        return r.id == id;
      });
    } else if (type == config.requirements) {
      item = this.state.requirements.filter(r => {
        return r.id == id;
      });
    }
    this.setState({ deleteRestrictionId: id });
    this.setState({ deleteRestrictionType: type });
    this.setState({ showConfirmRestrictionDelete: true });
    this.setState({ confirmDeleteRestrictionTitle: item[0].name });
    this.setState({
      confirmDeleteRestrictionMsg: `${
        type == config.conflicts ? label.deleteConfConfirmCustomMsg : label.deleteReqConfirmCustomMsg
      }`
    });
  }

  handleDeleteRestriction() {
    let c = this.state.deleteRestrictionId;
    if (c != '') {
      this.props.commonActions.deleteRestiction(this.state.deleteRestrictionId, this.state.deleteRestrictionType);
    }
    this.setState({ showConfirmRestrictionDelete: false });
  }

  closeDeleteModal() {
    this.setState({ showConfirmRestrictionDelete: false });
  }

  // Handle Conflict page change
  handleConflictPageChange(key) {
    this.setState({ activeConflictPage: key });
    if (key == 1) {
      this.setState({ startConf: 0, endConf: config.tableConflictNum });
    } else {
      let start = key * config.tableConflictNum - config.tableConflictNum;
      let end = key * config.tableConflictNum;
      this.setState({ startConf: start, endConf: end });
    }
  }

  // Handle Requirement page change
  handleRequirementPageChange(key) {
    this.setState({ activeReqPage: key });
    if (key == 1) {
      this.setState({ startReq: 0, endReq: config.tableConflictNum });
    } else {
      let start = key * config.tableConflictNum - config.tableConflictNum;
      let end = key * config.tableConflictNum;
      this.setState({ startReq: start, endReq: end });
    }
  }

  // File upload
  handleOnDrop(acceptedFiles) {
    this.setState({ uploadFileStatus: true });
    let runName = localStorage.getItem('run');
    this.props.runActions
      .uploadFile(acceptedFiles[0], runName)
      .then(() => {
        localStorage.removeItem('assignTime');
        localStorage.removeItem('assignUrl');
        this.setState({ uploadFileStatus: false });
        this.props.runActions.getRun();
        this.props.commonActions.getAllRestrictions(config.conflicts).catch(() => {
        });
        this.props.commonActions.getAllRestrictions(config.requirements).catch(() => {
        });
        this.props.courseActions.getAllCourses().then(() => {
          if (this.refs.restrictions) {
            this.setState({ coursesLoaded: true });
          }
        });
        this.props.studentsActions.getAllStudents();
        this.props.groupActions.getAllGroups();
      })
      .catch(() => {
        toastr.error('Upload File time out.');
      });
  }

  handleDropzone() {
    window.location.href = 'https://api.cognomos.com/static/ExampleInput.xlsx';
  }

  // Run form handle
  handleRunFormSubmit(values) {
    this.setState({ submittingRunFormProgress: true });
    let data = {
      longname: values.longname,
      primary_contact: values.primary_contact,
      allow_students_min_change: values.allow_students_min_change,
      allow_students_max_change: values.allow_students_max_change,
      send_student_emails: values.send_student_emails,
      additional_student_text: values.additional_student_text,
      additional_find_classes: values.additional_find_classes,
      additional_rank_classes: values.additional_rank_classes,
      additional_view_schedules: values.additional_view_schedules,
      ranking_session_not_open_text: values.ranking_session_not_open_text
    };
    this.props.runActions.updateRun(data).then(() => {
      this.setState({ submittingRunFormProgress: false });
    });
  }

  // Elicitation handle
  handleOpenRankingSession = () => {
    this.setState({
      showRankingSessionModal: true
    })
  }

  handleOpenRankingSessionSubmit = (emailStudents) => {
    this.props.commonActions.openRankingSession(
      this.props.run.slug,
      emailStudents
    )

    this.setState({
      showRankingSessionModal: false,
      progressStatus: 'elicitation'
    })
  }

  handleCloseRankingSession() {
    this.setState({ closeRankingSessionStatus: true });
    this.props.runActions.stopElicitation().then(() => {
      this.setState({ closeRankingSessionStatus: false });
      this.props.runActions.getRun();
    });
  }

  handleAssignClasses() {
    this.setState({ assignClassesStatus: true });
    this.props.runActions
      .startRun()
      .then(() => {
        localStorage.removeItem('assignUrl');
        localStorage.removeItem('assignTime');
        this.setState({ assignClassesStatus: false });
        this.props.runActions.getRun();
      })
      .catch(() => {
        toastr.error('Assign Classes time out.');
      });
  }

  handleCancelAssignment() {
    this.setState({ cancelAssignClassesStatus: true });
    this.props.runActions
      .stopRun()
      .then(() => {
        localStorage.removeItem('assignStopUrl');
        localStorage.removeItem('assignStopTime');
        this.setState({ cancelAssignClassesStatus: false });
        this.props.runActions.getRun();
      })
      .catch(() => {
        toastr.error('Cancel Assignment time out.');
      });
  }

  handleDownloadComputation = type => () => {
    const { currentComputationId } = this.props;
    const activeId = currentComputationId.value ? currentComputationId.value : currentComputationId;
    let downObj = {
      fileType: type,
      computation: activeId
    };
    localStorage.setItem('downloadFile', JSON.stringify(downObj));
    this.makeOutput(activeId, type);
  };

  makeOutput(computation, type) {
    if (type == 'json') {
      this.setState({ downloadJsonProgress: true });
    } else if (type == 'excel') {
      this.setState({ downloadExcelProgress: true });
    }
    this.props.runActions
      .makeOutput(computation, type)
      .then(url => {
        this.setState({
          downloadJsonProgress: false,
          downloadExcelProgress: false
        });
        localStorage.removeItem('downloadFile');
        localStorage.removeItem('downloadTime');
        window.location.href = url;
      })
      .catch(() => {
        toastr.error('Download Time Out. Try again later.');
        this.setState({
          downloadJsonProgress: false,
          downloadExcelProgress: false
        });
        localStorage.removeItem('downloadFile');
        localStorage.removeItem('downloadTime');
      });
  }

  // Run Status Calculate
  progressStatus(run) {
    if (run.id) {
      let is_eliciting = run.is_eliciting;
      let running_computations = run.running_computations.length;
      let students_with_rankings = run.students_with_rankings;

      if (!is_eliciting && running_computations == 0 && students_with_rankings == 0) {
        this.setState({ progressStatus: 'creation' });
      } else if (is_eliciting && running_computations == 0) {
        this.setState({ progressStatus: 'elicitation' });
      } else if (!is_eliciting && running_computations == 0 && students_with_rankings != 0) {
        this.setState({ progressStatus: 'modification' });
      } else if (!is_eliciting && running_computations > 0) {
        this.setState({ progressStatus: 'calculation' });
      }
    }
  }

  // Handle Restriction item Search
  handleRestrictionSearch(e, type) {
    e.preventDefault();
    let term = e.target.value;
    if (term != '') {
      let arrUnique = this.props.runActions.searchRestrictions(
        term,
        type == config.conflicts ? this.props.conflicts : this.props.requirements,
        this.props.courses
      );

      type == config.conflicts
        ? this.setState({
            conflicts: arrUnique,
            startConf: 0,
            endConf: 10,
            activeConflictPage: 1
          })
        : this.setState({
            requirements: arrUnique,
            startReq: 0,
            endReq: 10,
            activeReqPage: 1
          });
    } else {
      type == config.conflicts
        ? this.setState({ conflicts: this.props.conflicts })
        : this.setState({ requirements: this.props.requirements });
    }
  }

  // Bind conflicts or requirements to local state
  setRestrictionsToState(restrictions, type) {
    if (type == config.conflicts) {
      this.setState({ conflicts: restrictions });
    } else if (type == config.requirements) {
      this.setState({ requirements: restrictions });
    }
  }

  // Calculate estimated time for running computation
  cRunningComp(computationId) {
    this.props.runActions.getComputation(computationId).then(res => {
      let now = moment(new Date());
      let start = moment(res.created_at);
      let end = moment(res.estimated_completion_time);
      let duration = moment.duration(end.diff(start)).asHours();
      let left = moment.duration(end.diff(now)).asHours();
      let percentage = (100 - (left * 100) / duration).toFixed(0);
      this.setState({
        computation: {
          running: true,
          now,
          start,
          end,
          duration,
          left,
          percentage
        }
      });
    });
  }

  loopComputationStatus(id) {
    setInterval(() => {
      this.cRunningComp(id);
    }, 120000);
  }

  handleAssignmentSummary = () => () => {
    this.setState({ assignmentSummaryProgress: true });
    const { currentComputationId } = this.props;
    const activeId = currentComputationId.value ? currentComputationId.value : currentComputationId;
    this.props.runActions
      .getAllocations(activeId)
      .then(() => {
        let runName = localStorage.getItem('run');
        browserHistory.push(`/administer/${runName}/assignment/dashboard/${activeId}`);
      })
      .catch(err => {
        this.setState({ assignmentSummaryProgress: false });
      });
  };

  parseAssignmentsOptions = (assignmentIds) => {
    const result = assignmentIds && assignmentIds.map(item => {
      if (!item || !item.id) {
        return null;
      }
      return {
        option: `Computation ${item.id} - ${moment(item.created_at).format('ll')}`,
        value: item.id
      };
    }).filter(Boolean) || [];
    
    return result;
  }


  handleOpenRankingSessionModalClose = () => {
    this.setState({
      showRankingSessionModal: null
    })
  }

  renderAssignmentPeriodRestrictionSection = () => (
    <div>
      <div className="page-subtitle">{label.assignRestrictions}</div>
        {this.state.coursesLoaded ? (
          <Row className="mt-4">
            <Col md={12}>
              <span className="subtitle">Conflicts</span>
              <span className="add-new">
                <i
                  onClick={() => {
                    this.openAddConflictModal();
                  }}
                  className="fa fa-plus-circle ml-1"
                />
              </span>
            </Col>
          </Row>
        ) : null}
        <Row ref="restrictions">
          <Col md={12}>
            {this.state.coursesLoaded ? (
              <div>
                <div className="form-group mt-2 mb-2 restriction-search">
                  <span className="fa fa-search" />
                  <input
                    name="conflictSearchInput"
                    onChange={e => {
                      this.handleRestrictionSearch(e, config.conflicts);
                    }}
                    type="text"
                    className="form-control"
                    placeholder="Conflict Name, Course Name/Slug..."
                  />
                  <span className="input-description">
                    Type conflict name, course slug or name to filter conflicts
                  </span>
                </div>
                <Row>
                  <Col md={12}>
                    <Pagination
                      bsSize="small"
                      items={Math.ceil(this.state.conflicts.length / config.tableConflictNum)}
                      activePage={this.state.activeConflictPage}
                      onSelect={this.handleConflictPageChange}
                    />
                  </Col>
                </Row>
                {this.state.conflicts.length > 0 ? (
                  <Row>
                    <Col md={12}>
                      <div>
                        {this.state.conflicts
                          .slice(this.state.startConf, this.state.endConf)
                          .map((conflict, index) => {
                            return (
                              <ConflictRow
                                key={index}
                                c={conflict}
                                courses={this.props.courses}
                                onDelete={this.showConfirmRestrictionDeleteModal}
                                handleEdit={this.openEditConflictModal}
                              />
                            );
                          })}
                      </div>
                    </Col>
                  </Row>
                ) : null}
                <Row>
                  <Col md={12}>
                    <Pagination
                      bsSize="small"
                      items={Math.ceil(this.state.conflicts.length / config.tableConflictNum)}
                      activePage={this.state.activeConflictPage}
                      onSelect={this.handleConflictPageChange}
                    />
                  </Col>
                </Row>

                <Row className="mt-4">
                  <Col md={12}>
                    <span className="subtitle">Requirements</span>
                    <span className="add-new">
                      <i
                        onClick={() => {
                          this.openAddReqModal();
                        }}
                        className="fa fa-plus-circle ml-1"
                      />
                    </span>
                  </Col>
                </Row>

                <Row>
                  <Col md={12}>
                    <div className="form-group mt-2 mb-2 restriction-search">
                      <span className="fa fa-search" />
                      <input
                        name="conflictSearchInput"
                        onChange={e => {
                          this.handleRestrictionSearch(e, config.requirements);
                        }}
                        type="text"
                        className="form-control"
                        placeholder="Requirement Name, Course Name/Slug..."
                      />
                      <span className="input-description">
                        Type requirement name, course slug or name to filter requirements
                      </span>
                    </div>
                    <Row>
                      <Col md={12}>
                        <Pagination
                          bsSize="small"
                          items={Math.ceil(this.state.requirements.length / config.tableConflictNum)}
                          activePage={this.state.activeReqPage}
                          onSelect={this.handleRequirementPageChange}
                        />
                      </Col>
                    </Row>
                    {this.state.requirements.length > 0 ? (
                      <Row>
                        <Col md={12}>
                          <div>
                            {this.state.requirements
                              .slice(this.state.startReq, this.state.endReq)
                              .map((requirement, index) => {
                                return (
                                  <RequirementRow
                                    key={index}
                                    requirement={requirement}
                                    courses={this.props.courses}
                                    onDelete={this.showConfirmRestrictionDeleteModal}
                                    handleEdit={this.openEditReqModal}
                                  />
                                );
                              })}
                          </div>
                        </Col>
                      </Row>
                    ) : null}
                    <Row>
                      <Col md={12}>
                        <Pagination
                          bsSize="small"
                          items={Math.ceil(this.state.requirements.length / config.tableConflictNum)}
                          activePage={this.state.activeReqPage}
                          onSelect={this.handleRequirementPageChange}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            ) : this.props.conflicts.length == 0 ? (
              <div className="text-center">
                <h3>No conflicts.</h3>
              </div>
            ) : (
              <Spinner spinnerName="three-bounce" />
            )}
          </Col>
        </Row>
    </div>
  );

  assignmentPeriodRestrictionModals = () => (
    <div>
      <AddConflictModal
        closeModal={this.closeAddConflictModal}
        showModal={this.state.showConfModal}
        onCancel={this.closeAddConflictModal}
        initial={this.state.conflictModalValues}
      />
      <AddRequirementModal
        closeModal={this.closeAddReqModal}
        showModal={this.state.showReqModal}
        onCancel={this.closeAddReqModal}
        initial={this.state.reqModalValues}
      />
      <ConfirmDeleteModal
        closeModal={this.closeDeleteModal}
        showModal={this.state.showConfirmRestrictionDelete}
        onCancel={this.closeDeleteModal}
        customTitle={this.state.confirmDeleteRestrictionTitle}
        customMsg={this.state.confirmDeleteRestrictionMsg}
        confirmButtonTitle="Delete"
        onConfirm={this.handleDeleteRestriction}
      />
      <OpenRankingSessionIdModal
        showModal={this.state.showRankingSessionModal}
        onSubmit={this.handleOpenRankingSessionSubmit}
        onCancel={this.handleOpenRankingSessionModalClose}
        confirmButtonTitle="Open Ranking Session"
        runSlug={this.props.run.slug}
      />
    </div>
  );

  render() {
    // Extract finishedComputations from Redux state and assign to both variable names for consistency
    const { assignment_complete, is_eliciting } = this.props.run;
    
    const finished_computations = this.props.run.finishedComputations || [];
    const computations = finished_computations.length > 0
      ? this.parseAssignmentsOptions(finished_computations).reverse()
      : [];
    const computationId = computations[0] ? computations[0].value : 0;
    const assignmentFormInitialValues = {
      computationId: computationId
    };
    const runName = localStorage.getItem('run');
    if (assignment_complete)
      return (
        <Col md={12}>
          <div className="page-title">{label.manageAddDropPeriod}</div>
          <AdminSteps active="0" label={this.props.run.slug} assignment_complete />
          <AddDropPeriodComponent
            {...this.props}
            AssignmentPeriodRestriction={this.renderAssignmentPeriodRestrictionSection()}
            AssignmentPeriodRestrictionModals={this.assignmentPeriodRestrictionModals()}
          />
        </Col>
      );

    return (
      <Col md={12}>
        <div className="page-title">{label.manageAssignmentPeriod}</div>
        <AdminSteps active="0" label={this.props.run.slug} assignment_complete={assignment_complete} />

        <div>
          <Row>
            <Col md={8}>
              <div className="page-subtitle">
                <Row>
                  <Col md={10}>
                    <span className="sub-title-gray mr-2">{label.assignmentPeriod}</span>
                    {this.props.run.slug}
                  </Col>
                  <Col md={2} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                    <div>
                      <Badge style={{ color: 'white', backgroundColor: 'red' }}> {this.props.run.send_student_emails ? 'EMAIL ACTIVE' : 'EMAIL NOT ACTIVE'} </Badge>
                    </div>
                  </Col>
                </Row>


              </div>
              {!this.state.downloadExcelProgress &&
              !this.state.downloadJsonProgress &&
              !this.state.assignClassesStatus &&
              !this.state.cancelAssignClassesStatus &&
              !this.state.uploadFileStatus &&
              !this.state.assignmentSummaryProgress ? (
                <div>
                  {this.state.progressStatus.length > 0 ? (
                    <div className="progress-box">
                      <div className="progress-title">
                        {this.state.progressStatus == 'creation'
                          ? label.creationTitle
                          : this.state.progressStatus == 'elicitation'
                            ? label.elicitationTitle
                            : this.state.progressStatus == 'modification'
                              ? label.modificationTitle
                              : this.state.progressStatus == 'calculation'
                                ? label.calculationTitle
                                : null}
                      </div>
                      <p className="progress-message">
                        {this.state.progressStatus == 'creation'
                          ? `${label.creationMessage}`
                          : this.state.progressStatus == 'modification'
                            ? `${label.modificationMessage}`
                            : this.state.progressStatus == 'calculation'
                              ? `${label.calculationMessage}`
                              : null}
                      </p>
                      <div className="progress-buttons pull-right">
                        {this.state.progressStatus == 'creation' ? (
                          <button
                            onClick={this.handleOpenRankingSession}
                            disabled={this.state.openRankingSessionStatus}
                            className="btn btn-ter  mt-2"
                          >
                            {label.openRankingSession}
                          </button>
                        ) : this.state.progressStatus == 'elicitation' ? (
                          <button
                            onClick={this.handleCloseRankingSession}
                            disabled={this.state.closeRankingSessionStatus}
                            className="btn btn-ter  mr-2 m"
                          >
                            {label.closeRankingSession}
                          </button>
                        ) : this.state.progressStatus == 'modification' ? (
                          <div>
                            <button
                              onClick={this.handleOpenRankingSession}
                              disabled={this.state.openRankingSessionStatus || this.state.assignClassesStatus}
                              className="btn btn-ter  mr-2 mt-2"
                            >
                              {this.state.openRankingSessionStatus
                                ? label.openRankingSessionStatus
                                : label.reopenRankingSession}
                            </button>
                            <button
                              onClick={this.handleAssignClasses}
                              disabled={this.state.assignClassesStatus || this.state.openRankingSessionStatus}
                              className="btn btn-sec mt-2"
                            >
                              {this.state.assignClassesStatus ? label.assignClassesStatus : label.assignClasses}
                            </button>
                            {this.state.assignClassesStatus ? (
                              <p className="info mr-2 mt-1">Please be patient...</p>
                            ) : null}
                          </div>
                        ) : this.state.progressStatus == 'calculation' ? (
                          <div>
                            <button
                              onClick={this.handleCancelAssignment}
                              disabled={this.state.cancelAssignClassesStatus}
                              className="btn btn-ter mr-2"
                            >
                              {this.state.cancelAssignClassesStatus
                                ? label.cancelAssignmentStatus
                                : label.cancelAssignment}
                            </button>
                            {this.state.cancelAssignClassesStatus ? (
                              <p className="info mr-2 mt-1">Please be patient...</p>
                            ) : null}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  ) : (
                    <Spinner spinnerName="three-bounce" />
                  )}
                  {this.props.run.id &&
                  finished_computations.length > 0 &&
                  this.state.progressStatus != 'creation' ? (
                    <div className={'notification-primary mt-3'}>
                      <h2>{label.completedAssignmentHeader}</h2>
                      <p>{label.completedAssignmentMessage}</p>
                      {}
                      <div>
                        {assignmentFormInitialValues.computationId && (
                          <SelectAssignmentForm
                            computations={computations}
                            handleDownloadComputation={this.handleDownloadComputation}
                            handleAssignmentSummary={this.handleAssignmentSummary}
                            initialValues={assignmentFormInitialValues}
                          />
                        )}
                      </div>
                    </div>
                  ) : null}

                  {this.state.progressStatus == 'creation' ? (
                    <div className={'notification-primary mt-3'}>
                      <h2>{label.classUploadClasses}</h2>
                      <p>{label.classesUploadDescription}</p>
                      <div className="buttons mt-3">
                        <Row>
                          <Col md={4}></Col>
                          <Col md={4}>
                            <button onClick={this.handleDropzone} className="btn btn-ter mr-2">
                              {label.classExampleFile}
                            </button>
                            </Col>
                          <Col md={4}>
                           <Dropzone onDrop={this.handleOnDrop} className="dropzoneUpload">
                            <button type="button" className="btn btn-sec btn-sm btn-block">
                              {label.classImport}
                            </button>
                            <HelpBlock>Importing a new datasets completely erases any existing data in the current instance, including manual changes</HelpBlock>
                          </Dropzone>
                          </Col>
                        </Row>
                        
                      </div>
                    </div>
                  ) : null}

                  {this.props.run.id ? (
                    <RunForm
                      onSubmit={this.handleRunFormSubmit}
                      initialValues={{
                        slug: this.props.run.slug,
                        longname: this.props.run.longname,
                        primary_contact: this.props.run.primary_contact,
                        allow_students_min_change: this.props.run.allow_students_min_change,
                        allow_students_max_change: this.props.run.allow_students_max_change,
                        send_student_emails: this.props.run.send_student_emails,
                        additional_student_text: this.props.run.additional_student_text,
                        additional_find_classes: this.props.run.additional_find_classes,
                        additional_rank_classes: this.props.run.additional_rank_classes,
                        additional_view_schedules: this.props.run.additional_view_schedules,
                        ranking_session_not_open_text: this.props.run.ranking_session_not_open_text
                      }}
                      extended={!assignment_complete}
                      progress={this.state.submittingRunFormProgress}
                    />
                  ) : null}

                  {this.renderAssignmentPeriodRestrictionSection()}
                </div>
              ) : (
                <div className="spinner-box">
                  {this.state.downloadExcelProgress || this.state.downloadJsonProgress ? (
                    <h3 className="text-center mb-3">Downloading, please wait...</h3>
                  ) : this.state.assignClassesStatus ? (
                    <h3 className="text-center mb-3">
                      Assignment is starting. This can take few minutes, please stay on page.
                    </h3>
                  ) : this.state.cancelAssignClassesStatus ? (
                    <h3 className="text-center mb-3">
                      Assignment is stopping. This can take few minutes, please stay on page.
                    </h3>
                  ) : this.state.uploadFileStatus ? (
                    <h3 className="text-center mb-3">Uploading file...</h3>
                  ) : this.state.assignmentSummaryProgress ? (
                    <h3 className="text-center mb-3">Creating summary...</h3>
                  ) : null}
                  <Spinner spinnerName="three-bounce" className="mt-4" />
                </div>
              )}
            </Col>
            <Col md={4}>
                {this.state.progressStatus != 'calculation' ? (
                  <div className="sidebar-container">
                    <div className="sidebar-header">{label.progressSidebarTitle}</div>
                    <div className="progress-box mt-4">
                      {this.state.progress ? this.state.progress + '% completed' : '0' + '% completed'}
                      <div className="progress">
                        <div
                          className="progress-bar"
                          role="progressbar"
                          aria-valuenow="70"
                          aria-valuemin="0"
                          aria-valuemax="100"
                          style={{ width: this.state.progress + '%' }}
                        />
                      </div>
                      <p>{this.state.progressMsg}</p>
                    </div>
                  </div>
                ) : null}

                {this.state.computation.running && this.state.progressStatus == 'calculation' ? (
                  <div className="sidebar-container mt-3">
                    <div className="sidebar-header">{label.assignmentStatus}</div>
                    <div className="progress-box mt-4">
                      <div>
                        {this.state.computation.percentage < 95
                          ? this.state.computation.percentage + '% completed'
                          : null}
                      </div>

                      {this.state.computation.percentage < 95 ? (
                        <div className="progress">
                          <div
                            className="progress-bar"
                            role="progressbar"
                            aria-valuenow="70"
                            aria-valuemin="0"
                            aria-valuemax="100"
                            style={{
                              width: this.state.computation.percentage + '%'
                            }}
                          />
                        </div>
                      ) : null}

                      <p>
                        {Math.floor(this.state.computation.left) > 1
                          ? 'About ' + Math.floor(this.state.computation.left) + ' hours left.'
                          : 'Less than an hour left.'}
                      </p>
                    </div>
                  </div>
                ) : null}

                {finished_computations.length > 0 &&
                  assignment_complete === false && is_eliciting === false && (
                    <div className="sidebar-container sidebar-raw">
                      <div className="publish-box">
                        <Link className="btn btn-block" to={`/administer/${runName}/assignment/publish`}>
                          PUBLISH ASSIGNMENT <i className="fa fa-angle-double-right" aria-hidden="true"></i>
                        </Link>
                        <p>
                          This will close Assignment Period and open the Add/Drop Period using an assignment of student
                          schedules that you select
                        </p>
                      </div>
                    </div>
                  )}
              </Col>
            </Row>
            {this.assignmentPeriodRestrictionModals()}
          </div>
      </Col>
    );
  }
}

function mapStateToProps(state) {
  const assignmentFormSelector = formValueSelector('SelectAssignmentForm');
  return {
    run: state.run,
    conflicts: state.conflicts,
    requirements: state.requirements,
    courses: state.courses,
    groups: state.groups,
    form: state.form,
    currentComputationId: assignmentFormSelector(state, 'computationId')
  };
}

function mapDispatchToProps(dispatch) {
  return {
    runActions: bindActionCreators(runActions, dispatch),
    courseActions: bindActionCreators(courseActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
    studentsActions: bindActionCreators(studentsActions, dispatch),
    groupActions: bindActionCreators(groupActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RunPage);



// WEBPACK FOOTER //
// ./src/components/runs/RunPage.js